var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLines({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42178",
    "data-name": "Group 42178",
    transform: "translate(-1043 -946)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "tr-icon",
    id: "Path_37500",
    "data-name": "Path 37500",
    d: "M2,8A1,1,0,0,1,3,7H21a1,1,0,0,1,0,2H3A1,1,0,0,1,2,8Z",
    transform: "translate(1041 939)",
    fill: "#24b8c0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tr-icon",
    id: "Path_37501",
    "data-name": "Path 37501",
    d: "M2,12a1,1,0,0,1,1-1H21a1,1,0,0,1,0,2H3A1,1,0,0,1,2,12Z",
    transform: "translate(1041 939)",
    fill: "#24b8c0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tr-icon",
    id: "Path_37502",
    "data-name": "Path 37502",
    d: "M3,15a1,1,0,0,0,0,2H15a1,1,0,0,0,0-2Z",
    transform: "translate(1041 939)",
    fill: "#24b8c0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.05bb29f1e20c81ba5d46e7892ba9b2ff.svg";
export { ForwardRef as ReactComponent };